module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("My Information")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Please let us know about your detailed information:")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editDetails) ? _c('module-form', {
    key: "info-form",
    attrs: {
      "form-id": "dashboard-info",
      "fields": _vm.fields,
      "button-size": "m",
      "button": "primary",
      "submit": "Save Changes",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  }, [_c('module-button', {
    attrs: {
      "slot": "submit-extras",
      "button": "tertiary",
      "size": "m",
      "type": "button",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleEdit()
      }
    },
    slot: "submit-extras"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editDetails) ? _c('div', {
    key: "info-details"
  }, [(_vm.aboutItems) ? _c('module-detail-list', {
    attrs: {
      "title": "About",
      "items": _vm.aboutItems
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addressItems) ? _c('module-detail-list', {
    attrs: {
      "title": "Address Information",
      "items": _vm.addressItems
    }
  }) : _vm._e(), _vm._v(" "), _c('module-button', {
    attrs: {
      "size": "m",
      "level": "secondary",
      "button": "secondary",
      "label": "Edit my details"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleEdit()
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694db4de"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/profile/MyInfo.vue
// module id = 333
// module chunks = 0